export default __webpack_public_path__ + "static/media/footer-home-noti.cd55ad79.png";